import Model, { attr, belongsTo } from "@ember-data/model";
import { task } from "ember-concurrency";
import { service } from "@ember/service";
import { CONNECTION_TYPES } from "glesys-controlpanel/utils/network-utils";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

export default class NetworkAdapterModel extends Model {
  @service("cost") costService;

  @attr("string") adapterType;
  @attr("number") bandwidth;
  @attr("string") name;
  @attr("string") state;

  @attr("boolean") isconnected;
  @attr("boolean") isprimary;
  @attr("string") macaddress;

  @belongsTo("network", { async: false, inverse: "networkAdapters" }) network;
  @belongsTo("server", { async: false, inverse: "networkAdapters" }) server;
  @belongsTo("private-network-segment", { async: false, inverse: "networkAdapters" }) segment;

  get cost() {
    return this.costService.forNetworkAdapter(this.bandwidth, this.server, this.network);
  }

  get isLocked() {
    return this.state === "locked";
  }

  get isReady() {
    return this.state === "ready";
  }

  get networkConnectionType() {
    if (this.network?.id?.startsWith("vl")) {
      return CONNECTION_TYPES.VLAN;
    } else if (this.network?.id?.startsWith("internet")) {
      return CONNECTION_TYPES.INTERNET;
    }
    return CONNECTION_TYPES.PRIVATE;
  }

  /* TASKS */

  deleteTask = task(async () => {
    this.deleteRecord();

    try {
      await this.store.request(saveRecord(this));
    } catch (error) {
      this.rollbackAttributes();

      throw error;
    }
  });

  editTask = task(async (properties) => {
    if (this.server.isKVM) {
      this.name = properties.name;
    } else {
      if (properties.segment) {
        this.segment = properties.segment;
        this.network = null;
      } else if (properties.network) {
        this.network = properties.network;
        this.segment = null;
      }
      this.bandwidth = properties.bandwidth;
    }
    await this.store.request(saveRecord(this));
  });
}
